import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1041_19712)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.8568 2.48683L5.62275 11.7202C5.56066 11.7826 5.48688 11.832 5.40564 11.8658C5.3244 11.8995 5.23729 11.9169 5.14931 11.9169C5.06134 11.9169 4.97423 11.8995 4.89299 11.8658C4.81175 11.832 4.73797 11.7826 4.67588 11.7202L1.10494 8.14595C1.04285 8.08362 0.969073 8.03416 0.88783 8.00042C0.806586 7.96667 0.719479 7.9493 0.631506 7.9493C0.543533 7.9493 0.456425 7.96667 0.375182 8.00042C0.293938 8.03416 0.220158 8.08362 0.158075 8.14595C0.0957455 8.20803 0.0462892 8.28181 0.0125432 8.36306C-0.0212028 8.4443 -0.0385742 8.5314 -0.0385742 8.61938C-0.0385742 8.70735 -0.0212028 8.79446 0.0125432 8.8757C0.0462892 8.95695 0.0957455 9.03073 0.158075 9.09281L3.73036 12.6644C4.1072 13.0406 4.61788 13.2518 5.15032 13.2518C5.68275 13.2518 6.19344 13.0406 6.57028 12.6644L15.8037 3.43302C15.8659 3.37095 15.9153 3.29721 15.949 3.21603C15.9827 3.13485 16 3.04782 16 2.95992C16 2.87203 15.9827 2.785 15.949 2.70382C15.9153 2.62264 15.8659 2.5489 15.8037 2.48683C15.7416 2.4245 15.6678 2.37504 15.5866 2.34129C15.5053 2.30755 15.4182 2.29018 15.3303 2.29018C15.2423 2.29018 15.1552 2.30755 15.0739 2.34129C14.9927 2.37504 14.9189 2.4245 14.8568 2.48683Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1041_19712",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgCheckMark;
